/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import _filter from "lodash/filter";
import onClickOutside from "react-onclickoutside";
import { jsx, css } from "@emotion/core";

import A from "../../../Anchor/Anchor";
import Link from "../../../Link/Link";

import { primary_light } from "../../../lib/colors";

import "./MegaMenu.scss";

class MegaMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openCategory: "",
    };
  }

  setOpenCategory = (category) => (event) => {
    event.preventDefault();

    const { openCategory } = this.state;

    if (openCategory !== category) {
      this.setState({
        openCategory: category,
      });
    } else {
      this.setState({
        openCategory: "",
      });
    }
  };

  onLinkClick = (event) => {
    this.setState({
      openCategory: "",
    });
    this.props.onLinkClick();
  };

  handleClickOutside = (event) => {
    // Chiudi menù solo se aperto
    // Altrimenti non funzionano link menu mobile
    if (this.props.showMegaMenu) {
      this.onLinkClick(event);
    }
  };

  renderSubcategories(category) {
    return category.subcategories.map((subcategory) => {
      return (
        <li key={subcategory.seoName}>
          <Link to={`#${category.type}`} onClick={""}>
            {subcategory.name}
          </Link>
        </li>
      );
    });
  }

  chunkArray(array, chunksNumber) {
    const chunkSize = Math.ceil(array.length / chunksNumber);
    return array.reduce((acc, value, index) => {
      const pos = Math.floor(index / chunkSize);
      if (!acc[pos]) {
        acc[pos] = [];
      }
      acc[pos].push(value);

      return acc;
    }, []);
  }

  renderColumnCategories(columnCategories, type) {
    return columnCategories.map((category) => {
      return (
        <li
          key={category.seoName}
          className={
            this.state.openCategory === category.seoName ? "category-open" : ""
          }
        >
          {category.subcategories && category.subcategories.length > 0 ? (
            <span>
              <A href="#" onClick={this.setOpenCategory(category.seoName)}>
                {category.name}
              </A>
              <ul className="subcategories">
                {this.renderSubcategories(category)}
              </ul>
            </span>
          ) : (
            <Link to={`#`} onClick={this.onLinkClick}>
              {category.name}
            </Link>
          )}
        </li>
      );
    });
  }

  renderCategories(categories, type) {
    const categoriesChunks = this.chunkArray(categories, 4);

    const categoriesJsx = categoriesChunks.map((columnCategories, index) => {
      return (
        <div className="col-sm-3" key={index}>
          <ul className="categories">
            {this.renderColumnCategories(columnCategories, type)}
          </ul>
        </div>
      );
    });

    return categoriesJsx;
  }

  render() {
    const { onLinkClick, primaryColor, categories, type } = this.props;

    const megaMenuStyle = css`
      .categories-container {
        .categories,
        .subcategories {
          li a {
            &:focus,
            &:hover {
              color: ${primaryColor};
            }
          }
        }
        .scrolling-section::-webkit-scrollbar-track {
          background: ${primary_light(primaryColor)};
        }
        .scrolling-section::-webkit-scrollbar-thumb {
          background: ${primaryColor};
        }
      }
    `;

    return (
      <div className="container">
        <div className="mega-menu" css={megaMenuStyle}>
          <div className="categories-container">
            <A href="#" className="close" onClick={onLinkClick}>
              &times;
            </A>
            <div className="scrolling-section">
              {this.renderCategories(categories, type)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(MegaMenu);
